exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-organisms-QuestionPrepare-___QuestionPrepare__container___2p-Uz {\n  height: 100%;\n  width: 100%;\n  background-color: #FFF;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.src-pc-components-organisms-QuestionPrepare-___QuestionPrepare__l-text___3_b0s {\n  width: 100%;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-pc-components-organisms-QuestionPrepare-___QuestionPrepare__container___2p-Uz",
	"l-text": "src-pc-components-organisms-QuestionPrepare-___QuestionPrepare__l-text___3_b0s"
};